export default __webpack_public_path__ + "static/media/EM1840.34I-42128_-25318_0.28f38f17.jpg";